import { copyDiaryApi } from '@/api/DiaryApi';
import DiaryListConstants from "@/store/constants/diaryListRecords";
import GlobalConstants from "@/store/constants/global"
export default {
  name: "ConfirmCopyDiaryModal",
  components: {
  },
  data() {
    return {
      isCopying: false,
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('confirm-copy-diary-modal');
      // モーダルを閉じる際にコピー状態をリセット
      this.isCopying = false;
    },
    async copyRecord() {
      // 既にコピー処理中の場合は何もしない
      if (this.isCopying) {
        console.log("⚠️ コピー処理中のため、重複実行を防止");
        return;
      }
      
      // コピー処理開始
      this.isCopying = true;
      console.log("🔵 copyRecord() 開始 - 新しいバックエンドAPI使用");
      
      // confirmAttrから必要なデータを取得
      const confirmAttr = this.$store.getters[GlobalConstants.GETTERS.getConfirmAttr];
      console.log("🔵 confirmAttr:", confirmAttr);
      console.log("🔵 confirmAttr.orderId:", confirmAttr?.orderId);
      
      const sourceDate = confirmAttr.orderId.sourceDate;
      const destDate = confirmAttr.orderId.destDate;
      const editor = confirmAttr.orderId.editor;
      const sourceDiary = confirmAttr.orderId.sourceDiary;
      
      console.log("🔵 コピーパラメータ - sourceDate:", sourceDate, "destDate:", destDate, "editor:", editor);
      console.log("🔵 sourceDiary:", sourceDiary);
      console.log("🔵 sourceDiary のプロパティ一覧:", Object.keys(sourceDiary || {}));
      console.log("🔵 sourceDiary.id:", sourceDiary?.id);
      console.log("🔵 sourceDiary.diaryId:", sourceDiary?.diaryId);
      
      // diaryIdプロパティも確認（バックエンドではdiaryIdかもしれない）
      const diaryId = sourceDiary?.id || sourceDiary?.diaryId;
      console.log("🔵 使用するdiaryId:", diaryId);
      
      if (!sourceDiary || !diaryId) {
        console.error("🔴 エラー: sourceDiary または diary ID が存在しません");
        console.error("🔴 sourceDiary:", sourceDiary);
        this.$store.commit(DiaryListConstants.COMMIT.setStateCopyFunction, false);
        this.$bvModal.show('bv-modal-mess');
        this.hideModal();
        this.isCopying = false;
        return;
      }

      try {
        // 新しいバックエンドAPIを呼び出し
        console.log("🔵 copyDiaryApi呼び出し開始");
        const response = await copyDiaryApi(
          diaryId, 
          destDate.format('YYYY-MM-DD'), 
          editor,
          confirmAttr.orderId.selectedDiaryPeriod || 'daytime'
        );
        
        console.log("🟢 copyDiaryApi成功 response:", response);
        console.log("🟢 response.data:", response.data);
        
        // レスポンスの構造に応じて成功判定を調整
        const isSuccess = response.data && (response.data.success !== false);
        console.log("🟢 コピー結果:", isSuccess ? "成功" : "失敗");
        
        this.$store.commit(DiaryListConstants.COMMIT.setStateCopyFunction, isSuccess);
        
        // コピー成功時に日誌一覧を再取得
        if (isSuccess) {
          console.log("🟢 コピー成功 - リフレッシュ処理開始");
          console.log("🟢 新しい日誌ID:", response.data.newDiaryId);
          
          const siteId = this.$store.getters[DiaryListConstants.GETTERS.getSiteSelected];
          
          try {
            // 遅延を入れてバックエンドでの処理完了を待つ
            await new Promise(resolve => setTimeout(resolve, 500));
            
            // 日誌編集一覧を再取得
            console.log("🟢 getDiariesEditingRecords呼び出し開始");
            await this.$store.dispatch(DiaryListConstants.DISPATCH.getDiariesEditingRecords, {
              siteId: siteId,
              month: destDate.format("MM"),
              year: destDate.format("YYYY")
            });
            
            // コピー先の日付に合わせて詳細データも更新
            console.log("🟢 setCalendarDate実行開始");
            this.$store.commit(DiaryListConstants.COMMIT.setCalendarDate, {
              date: destDate
            });
            
            // 親コンポーネントにコピー完了をイベント通知
            console.log("🟢 copy-diary-successイベント送信開始");
            this.$root.$emit('copy-diary-success', {
              date: destDate,
              sourceDate: sourceDate,
              period: sourceDiary.diaryPeriod || "daytime",
              newDiaryId: response.data.newDiaryId
            });
            
            // 日誌詳細データを再取得（コピー先の日付で取得）
            console.log("🟢 getDiariesRecords呼び出し開始");
            await this.$store.dispatch(DiaryListConstants.DISPATCH.getDiariesRecords, {
              siteId: siteId,
              month: destDate.format("MM"),
              year: destDate.format("YYYY"),
              day: destDate.format("DD"),
              period: sourceDiary.diaryPeriod || "morning"
            });
            
          } catch (error) {
            console.error("🔴 リフレッシュ処理中にエラー:", error);
          }
        }
        
        // APIの結果を受け取ってからメッセージモーダルを表示
        console.log("🟢 bv-modal-mess表示開始");
        this.$bvModal.show('bv-modal-mess');
        
      } catch (error) {
        console.error("🔴 copyDiaryApi失敗:", error);
        this.$store.commit(DiaryListConstants.COMMIT.setStateCopyFunction, false);
        // エラー時もメッセージモーダルを表示
        this.$bvModal.show('bv-modal-mess');
      } finally {
        // コピー処理終了（成功・失敗関係なく）
        this.isCopying = false;
      }

      //hide confirm modal
      console.log("🔵 confirm modal非表示");
      this.hideModal();
      
      //reset confirmAttr in global
      console.log("🔵 confirmAttr リセット");
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "", orderId: -1 });
      
      console.log("🔵 copyRecord() 完了");
    }
  },
};
